import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import IdentityAvatarContainer from '../../../../../../../../../../containers/global/identity/IdentityAvatarContainer';
import { AVATAR_SIZE_42 } from '../../../../../../../../../../constants/avatar-sizes';
import IdentityNameContainer from '../../../../../../../../../../containers/global/identity/IdentityNameContainer';
import Button from '../../../../../../../../../../components/global/Button';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  cartItem: PropTypes.object,
  onIdentitySelect: PropTypes.func.isRequired,
  isPurchased: PropTypes.bool,
};
const IdentityContainer = ({
  identity,
  cartItem,
  onIdentitySelect,
  isPurchased,
}) => {
  return (
    <Button
      btnStyle="link"
      className="identity-container mb-2"
      disabled={isPurchased}
      onClick={onIdentitySelect}
    >
      <IdentityAvatarContainer
        identity={identity}
        className="mr-2"
        size={AVATAR_SIZE_42}
      />

      <IdentityNameContainer
        className="text-dark text-extra-bold mr-1"
        identity={identity}
      />

      <div className="ml-auto d-flex align-items-center text-right">
        {isPurchased && <span className="text-success">Purchased</span>}
        {!isPurchased && (
          <Fragment>
            {cartItem ? (
              <span className="text-success">Added to cart!</span>
            ) : (
              <span className="text-primary">Add to cart</span>
            )}
          </Fragment>
        )}
      </div>
    </Button>
  );
};

IdentityContainer.propTypes = propTypes;

export default IdentityContainer;
